// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"7fb1d9d1","888":"b4020e36"}[chunkId] + ".chunk.css";
};